import type { RangeOption } from '@/app/shell/AppShell';

export interface TransactionDateBounds {
  from: string | undefined;
  to: string | undefined;
}

export interface ExplicitScopeDates {
  dateFrom?: string;
  dateTo?: string;
}

function formatDate(date: Date): string {
  return date.toISOString().slice(0, 10);
}

function formatEndOfDay(date: Date): string {
  return `${formatDate(date)}T23:59:59.999999Z`;
}

function subtractMonths(date: Date, months: number): Date {
  const result = new Date(date);
  const day = result.getUTCDate();
  result.setUTCDate(1);
  result.setUTCMonth(result.getUTCMonth() - months);
  const lastDay = new Date(Date.UTC(result.getUTCFullYear(), result.getUTCMonth() + 1, 0)).getUTCDate();
  result.setUTCDate(Math.min(day, lastDay));
  return result;
}

export function getTransactionDateBounds(range: RangeOption, today = new Date()): TransactionDateBounds {
  const to = formatEndOfDay(today);
  switch (range) {
    case '1M':
      return { from: formatDate(subtractMonths(today, 1)), to };
    case '3M':
      return { from: formatDate(subtractMonths(today, 3)), to };
    case 'YTD':
      return { from: `${today.getUTCFullYear()}-01-01`, to };
    case '1Y':
      return { from: formatDate(subtractMonths(today, 12)), to };
    case 'All':
      return { from: undefined, to: undefined };
  }
}

/** Converts the shell's date-only URL scope to the API's UTC boundaries. */
export function getScopeDateBounds({ dateFrom, dateTo }: ExplicitScopeDates): TransactionDateBounds {
  if (!dateFrom && !dateTo) return { from: undefined, to: undefined };
  if (!dateFrom || !dateTo) throw new Error('Transaction scope requires both dateFrom and dateTo.');
  return { from: dateFrom, to: `${dateTo}T23:59:59.999999Z` };
}
